import { InvoiceStatus } from '@features/invoices/enums/invoiceStatus'
import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'

import { useInvoice } from '../contexts/invoiceContext'

const statusesDisplayedInDetailsCard = [InvoiceStatus.Deleted]

export const useDisplayInvoiceDetailsCard = () => {
  const { invoice, isFetching } = useInvoice()

  const isCreditNote = isDocumentTypeCreditNote(invoice?.documentType)

  const hasRelatedInvoices = invoice?.relatedInvoices?.some((relatedInvoice) => relatedInvoice.invoiceId !== invoice.id)

  const shouldDisplayTransactionLink = isCreditNote ? !!invoice?.externalCreditNoteId : !!invoice?.externalInvoiceId
  const shouldDisplayCustomerLink = !!invoice?.customer?.externalContactId

  const shouldDisplayStatus = invoice?.status?.status && statusesDisplayedInDetailsCard.includes(invoice.status.status)

  const hasRelatedDocument = isCreditNote
    ? !!invoice?.invoiceId
    : !!(
        invoice?.referredCreditnoteId ||
        invoice?.estimateReference ||
        invoice?.approvedEstimateId ||
        hasRelatedInvoices
      )

  const shouldDisplayRelatedDocumentLinks = !!(invoice?.invoiceNumber && hasRelatedDocument)

  const shouldDisplayIssueDate = !!invoice?.issueDate

  const shouldDisplayRecurringReference = !!invoice?.recurringProfileId

  const shouldDisplayInvoiceDetailsCard =
    shouldDisplayTransactionLink ||
    shouldDisplayCustomerLink ||
    shouldDisplayRelatedDocumentLinks ||
    shouldDisplayIssueDate

  return {
    isLoading: isFetching,
    shouldDisplayCustomerLink,
    shouldDisplayInvoiceDetailsCard,
    shouldDisplayIssueDate,
    shouldDisplayRecurringReference,
    shouldDisplayRelatedDocumentLinks,
    shouldDisplayStatus,
    shouldDisplayTransactionLink,
  }
}
